import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ProtectedRoute } from "@/components/auth/protected-route";
import { AppShell } from "@/components/app-shell";
import { SignInPage } from "@/pages/sign-in.page";
import { SignUpPage } from "@/pages/sign-up.page";
import { HomePage } from "@/pages/home.page";
import { AiAssistantPage } from "@/pages/ai-assistant.page";
import { SettingsLayout } from "@/pages/settings/layout";
import { SettingsProfilePage } from "@/pages/settings/profile.page";
import { SettingsAiPage } from "@/pages/settings/ai.page";
import { SettingsWorkspacePage } from "@/pages/settings/workspace.page";
import { SettingsGettingStartedPage } from "@/pages/settings/getting-started.page";
import { SettingsConnectionsPage } from "@/pages/settings/connections.page";
import { SettingsCompaniesPage } from "@/pages/settings/companies.page";
import { SettingsObservabilityPage } from "@/pages/settings/observability.page";
import { DocsPage } from "@/pages/docs/docs.page";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: true, staleTime: 30_000 },
  },
});

function ShellLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/signup" element={<SignUpPage />} />

          <Route element={<ProtectedRoute />}>
            <Route element={<ShellLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/ai-assistant" element={<AiAssistantPage />} />
              <Route path="/docs" element={<DocsPage />} />
              <Route path="/docs/:slug" element={<DocsPage />} />

              <Route path="/settings" element={<SettingsLayout />}>
                <Route index element={<Navigate to="/settings/account" replace />} />
                <Route path="getting-started" element={<SettingsGettingStartedPage />} />
                <Route path="account" element={<SettingsProfilePage />} />
                <Route path="ai" element={<SettingsAiPage />} />
                <Route path="connections" element={<SettingsConnectionsPage />} />
                <Route path="observability" element={<SettingsObservabilityPage />} />
                <Route path="companies" element={<SettingsCompaniesPage />} />
                {/* Docs moved to the root /docs section — keep old links working. */}
                <Route path="help" element={<Navigate to="/docs" replace />} />
                <Route
                  path="help/:slug"
                  element={<Navigate to="/docs" replace />}
                />
                <Route path="workspace-overview" element={<SettingsWorkspacePage />} />
                <Route path="users" element={<SettingsWorkspacePage />} />
                <Route path="profile" element={<Navigate to="/settings/account" replace />} />
                <Route path="workspace" element={<Navigate to="/settings/workspace-overview" replace />} />
                <Route path="cli" element={<Navigate to="/settings/account" replace />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
